import { Registry } from '@react-registry'

export const tableBodyDeserializer = (el) => {
    return {
        type: 'tbody',
        attrs: {}
    }
}

Registry.register(tableBodyDeserializer, { id: 'table-body', registry: 'v2.deserializer' })